import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { PropertyAllInclusiveSectionViewModel, PropertyAllInclusiveSubSectionViewModel } from 'src/common/models';

import { PropertyDetailsSegment } from './property-details-segment';

interface PropertyAllInclusiveProps {
  analytics: AnalyticsStore;
  propertyAllInclusive: PropertyAllInclusiveSectionViewModel;
  isToggleHidden?: boolean;
}

export const PropertyAllInclusive: React.FunctionComponent<PropertyAllInclusiveProps> = ({
  analytics,
  propertyAllInclusive,
  isToggleHidden = false
}) => {
  if (!propertyAllInclusive) {
    return null;
  }

  const allInclusiveData =
    propertyAllInclusive && propertyAllInclusive.title && propertyAllInclusive.description && propertyAllInclusive.subSections;

  if (!allInclusiveData) {
    return null;
  }

  const allInclusiveAnalytics = analytics && analytics.setupTracker('.PropertyAllInclusive', 'SeeMore_SeeLess');

  return (
    <PropertyDetailsSegment
      analytics={allInclusiveAnalytics}
      dataStid="section-property-all-inclusive"
      errorBoundaryLabel="hotel.information.policies.propertyAllInclusive"
      isToggleHidden={isToggleHidden}
      rootClassName="property-all-inclusive"
      title={propertyAllInclusive.title}
    >
      <div data-stid="property-all-inclusive-section-description" className="all-t-padding-three">
        {propertyAllInclusive.description}
      </div>
      <div data-stid="property-all-inclusive-section-subsections" className="all-y-padding-three">
        <AllInclusiveSubSections subSections={propertyAllInclusive.subSections} />
      </div>
    </PropertyDetailsSegment>
  );
};

interface AllInclusiveSubSectionsProps {
  subSections: PropertyAllInclusiveSubSectionViewModel[];
}

const AllInclusiveSubSections = ({ subSections }: AllInclusiveSubSectionsProps) => {
  const subsectionTitleClasses = 'policies__header--secondary uitk-type-heading-500 uitk-type-bold';
  const noBulletClasses = 'all-t-margin-two uitk-type-300 pwa-theme--grey-700';
  const showSubSections = subSections && subSections.length > 0;

  if (!showSubSections) {
    return null;
  }

  return (
    <>
      {subSections.map((subSection, subsectionIndex) => (
        <div key={`all-inclusive-subsection-${subsectionIndex}`} className="all-y-padding-three">
          <div className={subsectionTitleClasses}>{subSection.title}</div>
          {subSection.descriptions.map((subsectionDesc, subsectionDescIndex) => (
            <div key={`all-inclusive-subsection-description-${subsectionDescIndex}`}>
              <div className={noBulletClasses}>{subsectionDesc}</div>
            </div>
          ))}
        </div>
      ))}
    </>
  );
};
